import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import documentsFetched, {
	type DocumentPayload,
	type DocumentsFetchedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentsFetched';
import documentsFetchFailed, {
	type DocumentsFetchFailedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentsFetchFailed';
import type FetchDocuments from '@Application/Beneficiaries/Documents/Queries/FetchDocuments';
import { getPaginated } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = DocumentsFetchedAction | DocumentsFetchFailedAction;

// `getPaginated` requires a mutable `results` array (it pushes subsequent pages into it); the
// dispatched action still carries the `readonly` form declared by the payload type.
type PaginatedDocuments = {
	totalRecords: number;
	results: DocumentPayload[];
};

export default (query: FetchDocuments) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Page indexing starts at 0 server-side; `rowsPerPage: 200` is the server's maximum accepted
			// `rows` value.
			const payload = await getPaginated<PaginatedDocuments>(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/documents`,
				{ page: 0, rowsPerPage: 200 },
			);

			const action = documentsFetched(
				payload,
				query.facilityId,
				query.subject.subjectId,
				query.subject.typeKey,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
